import type { FilterContentProps } from './WalletDetailsFilter.types';
import type { ReactElement } from 'react';

import { Button, Checkbox, Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import {
  resetFilters,
  setHideEmptyWallets,
  setHideSmallBalances,
  setHideUnsupportedTokens,
} from '../../../state/WalletDetailsSlice';

export function MoreFilter(props: FilterContentProps): ReactElement {
  const { t } = useTranslation();
  const { hideEmptyWallets, hideSmallBalances, hideUnsupportedTokens } = useAppSelector(
    (state) => state.walletDetails,
  );
  const dispatch = useAppDispatch();

  function renderOption(
    id: string,
    label: string,
    checked: boolean,
    onCheckedChange: (checked: boolean) => void,
  ): ReactElement {
    return (
      <Flex gap="2" align="start">
        <Checkbox
          id={id}
          size="2"
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(value as boolean)}
        />
        <Text as="label" size="2">
          {label}
        </Text>
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap="3">
      {props.showHeader && (
        <Flex align="center" justify="between" gap="2" py="1">
          <Heading size="2">{t('More')}</Heading>
          <Button
            id="more-filter-reset-to-default-btn"
            size="1"
            variant="ghost"
            color="gray"
            radius="full"
            onClick={() => dispatch(resetFilters())}>
            {t('Reset to default')}
          </Button>
        </Flex>
      )}
      <Flex direction="column" gap="2">
        {renderOption('small-balance', t('Hide small balances'), hideSmallBalances, (value) =>
          dispatch(setHideSmallBalances(value)),
        )}
        {renderOption('hide-empty', t('Hide empty wallets'), hideEmptyWallets, (value) =>
          dispatch(setHideEmptyWallets(value)),
        )}
        {renderOption(
          'hide-unsupported',
          t('Hide unsupported tokens'),
          hideUnsupportedTokens,
          (value) => dispatch(setHideUnsupportedTokens(value)),
        )}
      </Flex>
    </Flex>
  );
}
